import { defineComponent as _defineComponent } from 'vue'
import {
  getCurrentInstance,
  computed,
  nextTick,
  onMounted,
  ref,
  withDefaults,
  onUnmounted
} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    noPadding: { type: Boolean, default: false },
    noContentPadding: { type: Boolean, default: false }
  },
  setup(__props: any) {

const vm = getCurrentInstance()
// name: 'PageWrap2'

const pageWrapEl = ref<InstanceType<typeof HTMLElement>>()
const pageInnerpEl = ref<InstanceType<typeof HTMLElement>>()

const minHeight = ref(0)

const showHeader = computed(() => {
  return !!vm?.proxy.$slots.header
})

function setMinHeight() {
  const { top } = pageInnerpEl.value!.getBoundingClientRect()
  minHeight.value = document.body.clientHeight - top - 24
}
onMounted(() => {
  nextTick(() => {
    setMinHeight()
    window.addEventListener('resize', setMinHeight)
  })
})

onUnmounted(() => {
  window.removeEventListener('resize', setMinHeight)
})

return { __sfc: true,vm, pageWrapEl, pageInnerpEl, minHeight, showHeader, setMinHeight }
}

})